import LoanDashlet from './LoanDashlet'
import AchProcessorDashlet from './AchProcessorDashlet'
import CustomerDashlet from './CustomerDashlet'
import LoanAgreementDashlet from './LoanAgreementDashlet'
import PromotionDashlet from './PromotionDashlet'
import PortfolioDashlet from './PortfolioDashlet'
import BankDashlet from './BankDashlet'
import TestStrategyDashlet from './TestStrategyDashlet'
import NoteDashlet from './NoteDashlet'
import CognitoDashlet from './CognitoDashlet'
import { hasUserPermission } from "../../utils/permissionHelper"
import VerificationDashlet from "./VerificationDashlet";
import PreferredCommunicationsDashlet from "./PreferredCommunicationsDashlet";
import TestSendEmailDashlet from "./TestSendEmailDashlet";
import CustomerBankAccountDashlet from './CustomerBankAccountDashlet'
import BankChangeDashlet from './BankChangeDashlet'
import RewardPointDashlet from './RewardPointDashlet'

/**
 * Loop through the dashlets linked to the current module and render the needed component
 * @param module
 * @param row
 * @param dropdownOptions
 * @param user
 * @returns {*|string}
 */
export default function dashletDetailViewControl(module, row, dropdownOptions, user) {
  if (module) {
    const codeKey = module.code_key == 'payment_schedule' ? 'customer' : module.code_key;
    const relatedDashlets = [...module?.module_related_dashlets]
    relatedDashlets.sort((a, b) => {
      return a.display_rank - b.display_rank;
    })
    return relatedDashlets.map((e) => {
      const permissionNameLookup = {
        note_table: "customer_note_read"
      }
      const permissionlessDashletKeys = ['preferred_communications_table', 'cognito_table', 'test_send_email_table', 'bank_change_table'];

      if (!hasUserPermission(user.data.user_permission_options, permissionNameLookup[e.dashlet_key] || e.dashlet_key.replace('_table', '_read')) && permissionlessDashletKeys.indexOf(e.dashlet_key) < 0) {
        return ''
      }
      switch (e.dashlet_key) {
        case 'loan_table':
          const loanDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/loan/dashlet`
          return <LoanDashlet key={'loan'} endpointPath={loanDetailEndpoint} />
        case 'customer_table':
          const customerDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/customer/dashlet`
          return <CustomerDashlet key={'customer'} endpointPath={customerDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'bank_account_table':
          const customerBankAccountDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/bank_account/dashlet`
          return <CustomerBankAccountDashlet key={'customer_bank_account'} endpointPath={customerBankAccountDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'bank_change_table':
          const bankChangeEndpoint = `${process.env.REACT_APP_API_DOMAIN}/customer/${row.id}/bank_change/dashlet`
          return <BankChangeDashlet key={'bank_change'} endpointPath={bankChangeEndpoint} dropdownOptions={dropdownOptions} />
        case 'loan_agreement_table':
          const loanAgreementDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/loan_agreement_program/dashlet`
          return <LoanAgreementDashlet key={'loan_agreement'} endpointPath={loanAgreementDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'customer_reward_table':
          const rewardSummaryEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/reward_summary/dashlet`
          return <RewardPointDashlet key={'reward_point'} endpointPath={rewardSummaryEndpoint} customerId={row.id} />
        case 'promotion_table':
          const promotionDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/promotion/dashlet`
          return <PromotionDashlet key={'promotion'} endpointPath={promotionDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'ach_processor_table':
          const achProcessorDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/ach_processor/dashlet`
          return <AchProcessorDashlet key={'ach_processor'} endpointPath={achProcessorDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'portfolio_table':
          const portfolioDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/portfolio/dashlet`
          return <PortfolioDashlet key={'portfolio'} endpointPath={portfolioDetailEndpoint} />
        case 'bank_table':
          const bankDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/bank/dashlet`
          return <BankDashlet key={'bank'} endpointPath={bankDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'test_strategy_table':
          const testStrategyDetailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/test_strategy/dashlet`
          return <TestStrategyDashlet key={'test_strategy'} endpointPath={testStrategyDetailEndpoint} dropdownOptions={dropdownOptions} />
        case 'test_send_email_table':
          const testSendEmailEndpoint = `${process.env.REACT_APP_API_DOMAIN}/${codeKey}/${row.id}/test_send_email/dashlet`
          return <TestSendEmailDashlet key={'test_send_email'} endpointPath={testSendEmailEndpoint} dropdownOptions={dropdownOptions} />
        case 'note_table':
          return <NoteDashlet key={'note'} />
        case 'cognito_table':
          if (hasUserPermission(user.data.user_permission_options, 'cognito_read')) {
            return <CognitoDashlet key={'cognito'} customerId={row.id} />
          } else {
            return ''
          }
        case 'ssv_table':
          return <VerificationDashlet key={'verification'} customerId={row.id} />
        case 'preferred_communications_table':
          const preferredCommunicationsEndpoint = `${process.env.REACT_APP_API_DOMAIN}/customer/${row.id}/preferred_communications/dashlet`
          return <PreferredCommunicationsDashlet key={'preferred_communications'} endpointPath={preferredCommunicationsEndpoint} />
        default:
          return ''
      }
    })
  } else {
    return ''
  }
}
